import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';


export class BlockCategory extends BlockItem {
    protected _name: string;
    protected _url: string;

    public constructor(name: string, url: string, type: BlockItemType) {
        super(type);
        this._name = name;
        this._url = url;
    }

    public get name(){
        return this._name;
    }

    public get mubData():string|undefined{
        return !this.blockName ? this._mub : JSON.stringify({
            t: 'category',
            b: this.blockName,
            m:{
                
            }
        });
    }

    public set mubData(value: string|undefined){
        this._mub = value;
    }

}